import { isValid } from 'date-fns';
import { toEasternDateKey } from './formatDate';

// Day comparisons use the Eastern calendar. A device-local midnight (e.g. the board's selected day) falls on the
// same Eastern day for any US zone at or west of Eastern, so both instants and selected days compare correctly.
export function isDateGreaterThanOrEqual(a, b) {
    return toEasternDateKey(a) >= toEasternDateKey(b);
}

export function areDatesEqual(a, b) {
    return toEasternDateKey(a) === toEasternDateKey(b);
}

export function areDateTimesEqual(a: any, b: any) {
    var formattedDateA = a && isValid(new Date(a as any)) ? new Date(a).toISOString() : undefined;
    var formattedDateB = b && isValid(new Date(b as any)) ? new Date(b).toISOString() : undefined;

    return formattedDateA === formattedDateB;
}
